// Global registry of open add/edit forms (modals), so any "back" gesture can
// close the top-most one before the app navigates away. Module-level (not React
// context) so BackKeyHandler / BackButtonHandler can call it without prop-drilling.
//
// Each open form pushes a handler: { close(): void }
// LIFO — the most recently opened form is closed first, so a nested form (e.g.
// Add Family inside the Guest form) returns to its parent form, and the next
// back press closes that parent, and the next one leaves the page.
const stack = [];

// Register an open form. Returns an unregister fn (call on close/unmount).
export function pushForm(handler) {
  stack.push(handler);
  return () => {
    const i = stack.lastIndexOf(handler);
    if (i >= 0) stack.splice(i, 1);
  };
}

export function hasOpenForm() {
  return stack.length > 0;
}

// Close the top-most open form. Typed content is never cleared — one back press
// = one step back. Returns true if a form was closed (caller must not navigate).
export function closeTopForm() {
  const h = stack[stack.length - 1];
  if (!h) return false;
  try {
    if (h.close) h.close();
  } catch {
    /* a form that throws on close must not block navigation */
  }
  return true;
}

// Kept as the name the Android hardware-back handler uses; same behaviour.
export const handleFormBack = closeTopForm;
